module.exports = __webpack_public_path__ + "img/logo-afinef.482cc65a.png";